import React, { useCallback, useEffect, useState } from "react";

import "../../../Assets/CSS/bulkorder.css";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import { Box, Collapse, IconButton } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import OMSParentChildOrder from './omsParentChildOrder';
import moment from "moment";

function ExpandableRow(props) {
  const { row } = props;
  const [open, setOpen] = useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ bgcolor:open ? '#e2e8f0':'#f3f4f6'}}>
        <TableCell className="px-0 py-3">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell align="center">
          {moment(row.ordered_date).format('DD-MM-YYYY')}
        </TableCell>
        <TableCell align="center">{row.id}</TableCell>
        <TableCell align="center">{row.is_approved_status_special}</TableCell>
        <TableCell align="center">{row.payment_status || 'NA'}</TableCell>
      </TableRow>
      <TableRow >
        <TableCell  colSpan={6} className="p-0">
          <Collapse className="p-0" in={open} timeout="auto" unmountOnExit>
            <Box className=''>
              {open && (
                <OMSParentChildOrder searchOrderId='' parent_order_id={row.id}/>
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function OMSParentOrder({ searchOrderId, overDueAgenstLoading = "" }) {
  const [loadingData, setLoadingData] = useState([]);
  const [omsData, setOmsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalResults, setTotalResults] = useState(0);
  const [itemPerPage, setItemPerPage] = useState(15);
  const [pageNumberLimit, setPageLimit] = useState(15);
  const [maxPageLimit, setMaxLimit] = useState(5);
  const [minPageLimit, setMinLimit] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const getOMSData = useCallback(async () => {
    const url = `/api/parents/orders?page=${currentPage}&limit=${itemPerPage}&status=Approved`;

    try {
      setLoading(true);
      const { data } = await axios.get(url);
      if (data.status) {
        setTotalResults(data?.parent_orders?.count);
        setOmsData(data?.parent_orders?.rows);
      } else {
        setTotalResults(0);
        setOmsData([]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }, [page, currentPage, searchOrderId]);

  useEffect(() => {
    getOMSData();
  }, [page, currentPage]);

  const pages = [];
  const handleClick1 = (event) => {
    setCurrentPage(Number(event.target.id));
    setPage(Number(event.target.id));
  };
  for (let i = 1; i <= Math.ceil(totalResults / itemPerPage); i++) {
    pages.push(i);
  }
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItem = loadingData.results?.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const handlePrevBtn = (e) => {
    if (currentPage === pages[0]) {
      return;
    }
    setPage(currentPage - 1);
    setCurrentPage(currentPage - 1);
    if ((currentPage - 1) % pageNumberLimit === 0) {
      setMaxLimit(maxPageLimit - pageNumberLimit);
      setMinLimit(minPageLimit - pageNumberLimit);
    }
  };

  const handleNextBtn = (e) => {
    if (currentPage === pages.length) {
      return;
    }
    setPage(currentPage + 1);
    setCurrentPage(currentPage + 1);
    if (currentPage + 1 > maxPageLimit) {
      setMaxLimit(maxPageLimit + pageNumberLimit);
      setMinLimit(minPageLimit + pageNumberLimit);
    }
  };

  const renderPageNumbers = pages
    ? pages.map((number, index) => {
        if (number < maxPageLimit + 1 && number > minPageLimit) {
          return (
            <li
              key={index}
              className={
                currentPage === number ? "page-item active" : "page-item"
              }
              style={{ cursor: "pointer" }}
              onClick={(e) => handleClick1(e)}
            >
              <a
                href="#overview-page"
                className="page-link pb-2 ps-3 pt-2 pe-3"
                id={number}
              >
                {number}
              </a>
            </li>
          );
        } else return null;
      })
    : "";

  return (
    <div className=" ms-0 ps-0 m-2 pt-0">
      <TableContainer component={Paper} className="overflow-x-scroll">
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead className="" style={{backgroundColor:'red'}}>
            <TableRow className="p-2">
                <TableCell />
              <TableCell align="center" className="">
                Ordered Date
              </TableCell>
              <TableCell align="center">Parent Order ID</TableCell>
              <TableCell align="center">Approval Status</TableCell>

              <TableCell align="center">Payment Status</TableCell>
            </TableRow>
          </TableHead>
          {loading ? (
            <>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell>
                <ClipLoader />
              </TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
            </>
          ) : (
            <TableBody>
              {omsData?.length === 0 ? (
                <>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell align="center">No Data Found</TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </>
              ) : (
                omsData?.map((row, index) => (
                  <ExpandableRow row={row} />
                ))
              )}
            </TableBody>
          )}
        </Table>
        {omsData?.length !== 0 && (
          <div className="row mx-auto mt-3">
            <div className="col-sm-6 pt-2 d-flex justify-content-start">
              Showing {15 * currentPage - (15 - 1)} to{" "}
              {15 * currentPage > totalResults
                ? totalResults
                : 15 * currentPage}{" "}
              entries of {totalResults ? totalResults : ""}
            </div>
            <div className="col-sm-6 d-flex justify-content-end">
              <ul className="pagination">
                <li className="page-item pt-1 pl-2 pr-2 border">
                  <a
                    href="#overview-page"
                    className={currentPage !== pages[0] ? "show" : "hideBtn"}
                    onClick={(e) => handlePrevBtn(e)}
                  >
                    Prev
                  </a>
                </li>
                {renderPageNumbers}
                <li className="page-item pt-1 pl-2 pr-2 border border-left-0">
                  <a
                    href="#overview-page"
                    className={
                      currentPage !== pages.length ? "show" : "hideBtn"
                    }
                    onClick={(e) => handleNextBtn(e)}
                  >
                    Next
                  </a>
                </li>
              </ul>
            </div>
          </div>
        )}
      </TableContainer>
    </div>
  );
}

export default OMSParentOrder;
